import React, { useEffect, useState } from "react";
import { PageHeaderUi } from "../../ui";
import { InventarioInicialScreen } from "./InventarioInicialScreen";
import { NewBtn } from "../../ui/Buttons";
import { Col, Row } from "antd";
import { InventarioInicialTable } from "./InventarioInicialTable";
import { useDispatch, useSelector } from "react-redux";
import {
  inventarioInicialClearActive,
  inventarioInicialStartLoad,
} from "../../../actions";
import { InventarioInicialTableSearchForm } from "./InventarioInicialTableSearchForm";

const InventarioInicialListScreen = ({ handleOpenForm }) => {
  const { inventariosIniciales, loading, paginator } = useSelector(
    (state) => state.inventario
  );
  return (
    <PageHeaderUi
      title="Inventarios iniciales"
      subTitle="Listado"
      extra={[<NewBtn key="nuevo" onClick={handleOpenForm} />]}
    >
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={24}>
          <InventarioInicialTableSearchForm />
        </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <InventarioInicialTable
            data={inventariosIniciales}
            loading={loading}
            handleOpenForm={handleOpenForm}
            paginator={paginator}
          />
        </Col>
      </Row>
    </PageHeaderUi>
  );
};

export const InventarioInicialList = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    dispatch(inventarioInicialStartLoad({}));
  }, []);
  const handleOpenForm = () => setOpen(true);
  const handleCloseForm = () => {
    dispatch(inventarioInicialClearActive());
    setOpen(false);
  };

  return (
    <>
      {open && <InventarioInicialScreen handleCloseForm={handleCloseForm} />}
      {!open && <InventarioInicialListScreen handleOpenForm={handleOpenForm} />}
    </>
  );
};
